import classes       from "./Result.module.scss"

import BoldTitle     from '../../../Titles/BoldTitle/BoldTitle';
import Cards         from '../../../Cards/Cards';
import Carousel      from '../../../Carousel/Carousel';

import graph         from "../../../Assets/Img/Src/Slider/Slider.jpg"
import graphWebp     from "../../../Assets/Img/Webp/Slider/Slider.webp"
import position      from "../../../Assets/Img/Src/Result/SeoCore.jpg"
import positionWebp  from "../../../Assets/Img/Webp/Result/SeoCore.webp"

import Tooltip       from '../../../Tooltip/tooltip';
import Image         from '../../../Image/Image';


const media = [
  {
    img: graph,
    imgWebp: graphWebp
  },
  {
    img: graph,
    imgWebp: graphWebp
  },
  {
    img: graph,
    imgWebp: graphWebp
  }
]

const Result = () => {
   return (
    <div className={classes.Result}> 
        <BoldTitle customClass={classes.Title} text="В результате анализа мы выявили следующее:"/>
      <div className={classes.Body}>
        <div className={classes.Item}>
          <Cards
           customClass={classes.Cards}
           number={"1."}
           title={<>Несмотря на постоянную работу SEO-специалистов мы видим большое количество недочётов в оптимизации сайта <Tooltip text={<>Это и отсутствие на страницах тегов <b>Description</b> и <b>Title</b>, отсутствие заголовков <b>h1</b>, наличие ошибок <b>404</b> (страница не найдена)</>}/></>}
           />
           <div className={classes.Carousel}>
              <Carousel media={media} id="firstStep" />
            </div>
        </div>
        <div className={classes.Attention}>
          <p className={classes.Text}>Тут стоит заметить, что мы показываем только те ошибки оптимизации, которые признает любой специалист по SEO.</p>
          <p className={classes.Text}>Мы не критикуем построение ссылочного профиля или плотность ключевых фраз на страницах – у каждой студии свой подход, универсального нет.</p>
        </div>

        <div className={classes.Seo}>

          <div className={classes.Image}>
                  <Image src={position} srcWebp={positionWebp}/>
          </div>

          <div className={classes.Item}>
            <Cards
              customClass={classes.CardsSm}
              customClassText={classes.CardsText}
              number={"2."}
              title={"Семантическое ядро, с которым работал последний подрядчик, содержало всего 46 ключевых запросов."}
              text={"При таком маленьком списке поисковых запросов невозможно понять какие позиции каких сегментов ключевых запросов растут, какие падают и определить причину изменений позиций в поисковой выдаче."}
              />
          </div>
          <div className={classes.Item}>
            <div className={classes.About}>
                <p className={classes.Text}>
                   Большое количество отслеживаемых запросов позволяет
                   гораздо точнее отслеживать динамику развития сайта, определять
                   узкие места и расставлять точки приложения усилий в продвижении.
                </p>
            </div>
          </div>
        </div>
        <div className={classes.Traffic}>
        <Cards
              customClass={classes.CardsSm}
              number={"03."}
              title={<>Трафик сайта с января 2015 по середину 2016 падает.<br/><br/> Мы провели исследования и поняли почему.</>}
        />
          <div className={classes.Block}>
              <p className={classes.Description}> 
                  Оказалось, что основная причина в том, что у компании ТОПОЛ-ЭКО экспоненциально растет количество дилеров. При этом каждый дилер делает <span className={classes.TooltipWrap}>свой сайт.<Tooltip/></span> Таким образом, в течение нескольких лет в <span className={classes.TooltipWrap}>SERP <Tooltip/></span>       пытаются попасть все больше и больше сайтов по одним и тем же запросам.
              </p>
              <p className={classes.Description +" "+ classes.Accent}> 
                Стоит отметить, что с 2016 по 2019 год стоимость запроса «топас» в Яндекс Директ возрастает с 150 рублей за клик до 2000 рублей за клик.
              </p>
              <p className={classes.Description}>
                  Соответственно, сайты дилеров ТОПОЛ-ЭКО забирают места у основного сайта компании ТОПОЛ-ЭКО.
              </p>
          </div>
        </div>
        <div className={classes.Other}>
          <Cards
                customClass={classes.CardsMd}
                number={"04."}
                title={<>Сам сайт компании ТОПОЛ-ЭКО морально и технически устарел, что сказывалось на низкой конверсии сайта.</>}
            />
           <Cards
              customClass={classes.CardsMd}
              number={"05."}
              title={<>Контент сайта давно не перерабатывался и не наращивается, если не считать раздел «Новости».</>}
          />
         <Cards
              customClass={classes.CardsMd}
              number={"06."}
              title={<>ТАнализ данных тепловых карт и работа с конверсионностью элементов сайта никогда не проводилась.</>}
         />
        </div>
      </div>
    </div>
   )
}
export default Result;